import css from 'styled-jsx/css';
import { common } from '../../theme/theme';

const style = css`
  .update-area-description-modal {
    width: 380px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 4px;
  }
  .update-area-description-wrapper {
    margin-bottom: 8px;
  }
  .update-area-description-modal :global(textarea.text-area) {
    resize: none;
    border: solid 1px #676767;
    border-radius: 4px;
    font-size: 16px;
  }
  .update-area-description-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .update-area-description-modal :global(.submit-button:hover) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .update-area-description-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .update-area-description-modal :global(.cancel-button:hover) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
